<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ query.categoryName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button
            v-if="tableAcl.indexOf('Add') != -1"
            class="btn primary"
            type="primary"
            size="small"
            v-preventReClick
            @click="handleAdd"
            >新增发票</el-button
          >
          <el-button
            v-if="tableAcl.indexOf('Edit') != -1"
            class="btn"
            size="small"
            :disabled="multiple"
            v-preventReClick
            @click="ToBuyOrSale"
          >
            {{ query.buyOrSale == "0" ? "转至付款" : "转至收款" }}
          </el-button>
          <el-button
            v-if="tableAcl.indexOf('Remove') != -1"
            class="btn"
            size="small"
            :disabled="multiple"
            v-preventReClick
            @click="handleDelete"
            >批量删除</el-button
          >
        </div>
        <div class="right">
          <div class="search">
            <el-input
              type="text"
              v-model="query.keyWord"
              @keyup.enter.native="queryChange"
            >
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset1">重置</span>
        </div>
      </div>
      <el-tabs v-model="query.buyOrSale" @tab-click="handleClick" stretch>
        <el-tab-pane
          v-for="item in InvoiceTypeModelOptions"
          :key="item.id"
          :name="item.id"
        >
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-table
        ref="multipleTable"
        border
        row-key="id"
        v-loading="loading"
        :data="tableData"
        :max-height="tableHeight"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        stripe
        :header-cell-style="{ background: '#DDEBFF' }"
      >
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span"
              >抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span
            >
            <div class="empty-rest" @click="reset1">恢复默认</div>
          </div>
        </template>
        <el-table-column
          align="center"
          :reserve-selection="true"
          type="selection"
          fixed
          width="55"
        >
        </el-table-column>
        <template v-for="(item, index) in tableColumn">
          <el-table-column
            :key="index"
            :align="item.align"
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :formatter="item.formatter"
            :show-overflow-tooltip="item.tooltip"
            :width="item.width"
            :min-width="item.minWidth"
            v-if="item.type == 'ware'"
          >
            <template slot-scope="scope">
              <div>
                {{
                  item.formatters.formatter1
                    ? item.formatters.formatter1(
                        null,
                        null,
                        scope.row[item.rowData.data1]
                      )
                    : scope.row[item.rowData.data1]
                }}
              </div>
              <div>
                {{
                  item.formatters.formatter2
                    ? item.formatters.formatter2(
                        null,
                        null,
                        scope.row[item.rowData.data2]
                      )
                    : scope.row[item.rowData.data2]
                }}
              </div>
            </template>
          </el-table-column>
          <!-- 日期 -->
          <el-table-column
            :key="index"
            :align="item.align"
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :formatter="item.formatter"
            :show-overflow-tooltip="item.tooltip"
            :width="item.width"
            v-else-if="item.type == 'Date'"
          >
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 时间 -->
          <el-table-column
            :key="index"
            :align="item.align"
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :formatter="item.formatter"
            :show-overflow-tooltip="item.tooltip"
            :width="item.width"
            v-else-if="item.type == 'DateTime'"
          >
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{h}:{i}:{s}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 普通列 -->
          <el-table-column
            v-else
            :key="index"
            :align="item.align"
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :formatter="item.formatter"
            :show-overflow-tooltip="item.tooltip"
            :width="item.width"
          ></el-table-column>
        </template>
        <el-table-column prop="payState" label="收款状态" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.payState == 0" style="color: #e8873d">
              {{ query.buyOrSale == "0" ? "未付款" : "未收款" }}
            </div>
            <div v-else-if="scope.row.payState == 1" style="color: #6ea204">
              {{ query.buyOrSale == "0" ? "部分付款" : "部分收款" }}
            </div>
            <div v-else-if="scope.row.payState == 2" style="color: #ce1126">
              {{ query.buyOrSale == "0" ? "已付全款" : "已收全款" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="isWorkflowTable"
          label="审批人"
          width="100"
          align="center"
          prop="approverNames"
        />
        <el-table-column
          prop="statusName"
          label="流程状态"
          width="80"
          v-if="isWorkflowTable"
        >
          <template slot-scope="scope">
            <approve-status
              :row="scope.row"
              :isWorkflowTable="isWorkflowTable"
              :options="ApproveStatusOptions"
              @success="getData"
              :tableCode="route.name"
            ></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-preventReClick
              @click="handleInfo(scope.row)"
              class="color-blue"
              >查看</el-button
            >
            <el-button
              v-if="CanEdit(scope.row) && tableAcl.indexOf('Edit') != -1"
              type="text"
              v-preventReClick
              @click="handleUpdate(scope.row)"
              class="margin-left20 color-blue"
              >编辑</el-button
            >
            <el-button
              v-else-if="
                scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)
              "
              type="text"
              v-preventReClick
              @click="handleApprove(scope.row)"
              class="margin-left20 color-blue"
              >审核</el-button
            >
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button
              v-if="
                query.buyOrSale != 0 &&
                tableAcl.indexOf('Remove') != -1 &&
                scope.row.state == 0
              "
              type="text"
              v-preventReClick
              @click="handleDelete(scope.row)"
              class="margin-left20 color-blue"
              >删除</el-button
            >
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
        :page-size="query.pageSize"
        @size-change="handleSizeChange"
        :current-page="query.pageIndex"
        :total="total"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import { InvoiceTypeModelOptions } from "@/enum";
import { GetPurchaseInvoices, RemovePurchaseInvoices } from "@/api";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {},
  /** 定义属性 */
  data() {
    return {
      GetDatasAction: GetPurchaseInvoices,
      RemoveAction: RemovePurchaseInvoices,
      // PrintAction: GetAcceptInStockPrintData,
      editPath: "purchase-invoice-edit",
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        type: "0",
        categoryName: "采购发票",
      },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      tableColumn: [],
      tableColumn1: [
        {
          label: "发票号码",
          prop: "no",
          minWidth: "100",
        },
        {
          label: "发票代码",
          prop: "billCode",
          minWidth: "100",
        },
        {
          type: "Date",
          label: "开票日期",
          prop: "createdTime",
          width: "140",
        },
        {
          label: "发票类型",
          prop: "typeName",
          width: "120",
        },
        {
          label: "单据类型",
          prop: "categoryName",
          width: "120",
        },
        {
          type: "ware",
          label: "创建人/创建时间",
          rowData: {
            data1: "createdUserName",
            data2: "createdTime",
          },
          formatters: {
            formatter2: (val) => {
              return val;
            },
            formatter2: this.DateTimeFomatter,
          },
          minWidth: "160",
        },
        {
          type: "ware",
          label: "开票总数量/金额",
          rowData: {
            data1: "totalNumber",
            data2: "totalAmount",
          },
          formatters: {
            formatter1: this.toDecimal2,
            formatter2: this.toDecimal4,
          },
          minWidth: "140",
        },
      ],
      tableColumn2: [
        {
          label: "发票号码",
          prop: "no",
          minWidth: "100",
        },
        {
          label: "发票代码",
          prop: "billCode",
          minWidth: "100",
        },
        {
          type: "Date",
          label: "开票日期",
          prop: "createdTime",
          width: "140",
        },
        {
          label: "发票类型",
          prop: "typeName",
          width: "120",
        },
        {
          label: "单据类型",
          prop: "categoryName",
          width: "120",
        },
        {
          type: "ware",
          label: "开票人/所属科室",
          rowData: {
            data1: "billUserName",
            data2: "billDeptName",
          },
          formatters: {},
          minWidth: "140",
        },
        {
          type: "ware",
          label: "创建人/创建时间",
          rowData: {
            data1: "createdUserName",
            data2: "createdTime",
          },
          formatters: {
            formatter2: (val) => {
              return val;
            },
            formatter2: this.DateTimeFomatter,
          },
          minWidth: "160",
        },
        {
          type: "ware",
          label: "开票总数量/金额",
          rowData: {
            data1: "totalNumber",
            data2: "totalAmount",
          },
          formatters: {
            formatter1: this.toDecimal2,
            formatter2: this.toDecimal4,
          },
          minWidth: "140",
        },
      ],
      InvoiceTypeModelOptions: InvoiceTypeModelOptions,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // refenceQuery () {
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //     buyOrSale: "0",
    //     categoryName: "采购发票",
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    // },
    // // 获取列表
    // getData () {
    //   GetPurchaseInvoices(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // // 查看信息
    // handleInfo (row) {
    //   this.$router.push(
    //     "/purchase-invoice-edit?formMode=0&id=" +
    //     row.id +
    //     "&buyOrSale=" +
    //     this.query.buyOrSale
    //   );
    // },
    // // 新建
    // handleAdd () {
    //   this.$router.push(
    //     "/purchase-invoice-edit?formMode=1" +
    //     "&buyOrSale=" +
    //     this.query.buyOrSale
    //   );
    // },
    // // 编辑
    // handleUpdate (row) {
    //   this.$router.push(
    //     "/purchase-invoice-edit?formMode=2&id=" +
    //     row.id +
    //     "&buyOrSale=" +
    //     this.query.buyOrSale
    //   );
    // },
    // // 审批
    // handleApprove (row) {
    //   this.$router.push(
    //     "/purchase-invoice-edit?formMode=3&id=" +
    //     row.id +
    //     "&buyOrSale=" +
    //     this.query.buyOrSale
    //   );
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // // 删除部门
    // handleDelete (row) {
    //   const ids = row && row.id ? [row.id] : this.ids;

    //   this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
    //     type: "warning",
    //   })
    //     .then(() => {
    //       return RemovePurchaseInvoices({ ids });
    //     })
    //     .then(() => {
    //       this.$my_message(`操作成功！`, "success");
    //       this.getData();
    //     })
    //     .catch(() => { });
    // },
    /**
     * 收款或付款
     */
    ToBuyOrSale() {
      switch (this.query.buyOrSale) {
        case "0":
          window.console.log("收款");
          break;
        case "1":
          window.console.log("付款");
          break;
      }
    },
    // 重置
    reset1() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        buyOrSale: "0",
        categoryName: "采购发票",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },
    handleClick(tab) {
      // this.query.buyOrSale =
      let item = this.InvoiceTypeModelOptions.find((e) => e.id == tab.name);
      if (item) {
        this.query.categoryName = item.name;
      }
      switch (tab.index) {
        case "0":
          this.tableColumn = this.tableColumn1;
          break;
        case "1":
          this.tableColumn = this.tableColumn2;
          break;
      }
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    CanEdit(row) {
      if (this.isAdmin) {
        // 是管理员
        return true;
      } else if (this.userInfo.id == row.userId) {
        // 是请款人/收款人
        return true;
      } else if (this.userInfo.id == row.createdUser) {
        // 是创建人
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created() {
    this.tableColumn = this.tableColumn1;
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted() {
    // this.getData();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate() {},
  /** 生命周期 - 挂载之前 */
  beforeMount() {},
  /** 生命周期 - 更新之前 */
  beforeUpdate() {},
  /** 生命周期 - 更新之后 */
  updated() {},
  /** 生命周期 - 销毁之前 */
  beforeDestroy() {},
  /** 生命周期 - 销毁完成 */
  destroyed() {},
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated() {},
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 200px;
  margin-bottom: 10px;
}
.pagination {
  padding-top: 10px;
}
</style>
